/** Grups del menú d'Ajustos (claus d'ELEMENTS_NAV / rutes ocultes d'administració). */
export const GRUPS_AJUSTOS: { clau: string; items: string[] }[] = [
  { clau: 'organitzacio', items: ['arees', 'zones'] },
  { clau: 'persones', items: ['usuaris', 'rols'] },
  { clau: 'avisos', items: ['circuits', 'canals', 'plantilles', 'usuarisInformar'] },
  { clau: 'documentacio', items: ['documentacio', 'politicaFitxers'] },
  { clau: 'sistema', items: ['integracions', 'monitoratge', 'versions', 'configuracio'] },
];
